import React, { useState } from "react";
import { Link, useRouteMatch } from "react-router-dom";
import useResponsiveHandler from '../../../hooks/useResponsiveHandler';

import "./sider.scss";
import {tabs} from "../../../constants/constants";

const SiderComponent = () => {
  const match = useRouteMatch();
  const [active, setActive] = useState("Заявки");
  const [isMobile, setIsMobile] = useState(false);

  useResponsiveHandler('xl', (matches) => {
    setIsMobile(matches);
  });

  const links = tabs.map((item) => (
    <Link
      className="link"
      data-active={item.label === active || undefined}
      key={item.label}
      to={`${match.url}/${item.link}`}
      onClick={() => {
        setActive(item.label);
      }}
    >
      <span className="icon">
        {item.icon}
      </span>
      <span className="title">{item.label}</span>
    </Link>
  ));

  return (
    <aside className={`content-inner-data-navbar request-sider ${isMobile ? 'sider-collapsed ' : ''}`}>
      <nav className="navbar">
        <div className="navbarMain">{links}</div>
      </nav>
    </aside>
  );
};

export default SiderComponent;
